var urlCollection = urlBase + '/shopify/api/collection/';
var urlPetDonated = urlBase + '/api/pets/pets_donated/';

document.addEventListener('DOMContentLoaded', function () {
  console.log('related-products');
  Vue.component('related-products', {
    template: '#related-products-template',
    props: {
      collection: {
        type: String
      },
      size: {
        type: Number,
        default: 2
      }
    },
    data: function () {
      return {
        products: [],
        product: undefined,
        page: 0,
        isPhone: false,
        isTablet: false,
      };
    },
    computed: {
      items: function () {
        if(this.isPhone) {
          return this.products;
        }
        var start = this.page * this.size;
        var end = start + this.size;
        var len = (this.products || []).length;
        if (len < end) {
          start = len - this.size;
          end = len;
        }
        return (this.products || []).slice(start, end);
      },
      maxPages: function () {
        return Math.floor(this.products.length / this.size);
      },
      emptyBlocks: function () {
        return this.size - (this.items || []).length;
      }
    },
    methods: {
      getCollection: function() {
        var self = this;
        console.log(this.collection);
        $.get(urlCollection + this.collection, function (data) {
          self.products = data.products;
          setTimeout(function() {calcSwipe(self.$refs['swipe']);}, 250);
        })
      },
      prev: function () {
        if (this.page > 0) {
          this.page -= 1;
        }
      },
      next: function () {
        if (this.page < this.maxPages) {
          this.page += 1;
        }
      }
    },
    mounted: function () {
      console.log('related products mounted');
      this.isPhone = window.isPhone;
      this.isTablet = window.isTablet;
      this.getCollection();
    }
  });

  Vue.component('donation-products', {
    template: '#donation-products-template',
    props: {
      size: {
        type: Number,
        default: 1
      },
      handleDogProduct: {
        type: String,
        default: ''
      },
      handleCatProduct: {
        type: String,
        default: ''
      }
    },
    data: function () {
      return {
        customer: window.shopivars.customer_id || 0,
      donatedPets: [],
        donatedPet1: {},
      donatedPet2: {},
      page: 0,
        viewMore: 0,
        dogProduct: {},
      catProduct: {},
      product: {},
      isPhone: false,
        isTablet: false
    };
    },
    computed: {
      items: function () {
        var start = this.page * this.size;
        var end = start + this.size;
        if ((this.donatedPets || []).length < end) {
          start -= 1;
          end -= 1;
        }
        if(this.isPhone || this.isTablet) {
          return (this.donatedPets || []);
        }
        return (this.donatedPets || []).slice(start, end);
      },
      maxPages: function () {
        return Math.floor(this.donatedPets.length / this.size) - 1;
      },
      emptyBlocks: function () {
        return this.size - (this.items || []).length;
      }
    },
    watch: {
      donatedPets: function () {
        var data = '';
        for(var i=0; i < 2; i++) {
          if(this.donatedPets.length > i) {
            data += 'attributes[donado' + i + '_id]=' + this.donatedPets[i].id + '&';
            data += 'attributes[donado' + i + '_nombre]=' + this.donatedPets[i].name + '&';
            data += 'attributes[donado' + i + '_desc]=' + this.donatedPets[i].desc + '&';
            data += 'attributes[donado' + i + '_url]=' + this.donatedPets[i].url + '&';
            data += 'attributes[donado' + i + '_url_post]=' + this.donatedPets[i].url_post + '&';
            data += 'attributes[donado' + i + '_type]=' + this.donatedPets[i].type + '&';
          } else {
            data += 'attributes[donado' + i + '_id]=&';
            data += 'attributes[donado' + i + '_nombre]=&';
            data += 'attributes[donado' + i + '_desc]=&';
            data += 'attributes[donado' + i + '_url]=&';
            data += 'attributes[donado' + i + '_url_post]=&';
            data += 'attributes[donado' + i + '_type]=&';
          }
        }
        $.ajax({
          url: '/cart/update.js',
          data: data,
          type: 'POST',
          dataType: 'json'
        }).done(function (data) {
          console.log(data);
        }).fail(function (data) {
          console.log(data);
        });
      },
      viewMore: function (val) {
        if(val == 0) {
          var self = this;
          setTimeout(function() {calcSwipe(self.$refs['swipe']);}, 250);
        }
      },
      items: function () {
        if(this.isPhone || this.isTablet) {
          let self = this;
          setTimeout(function() {calcSwipe(self.$refs['swipe']);}, 250);
        }
      }
    },
    methods: {
      donated: function (val, petType) {
        let grams = 170;
        if(petType == 2) {
          grams = 90;
        }
        return Math.round(val * 20 / 30 / grams);
      },
      getDonatedPets: function(petType, donated) {
        console.log('ADDED', petType);
        var self = this;
        var donatedPet = localStorage.getItem('donatedPet' + petType);
        if(donatedPet) {
          donatedPet = JSON.parse(donatedPet);
          donatedPet.donated = donated;
          this['donatedPet' + petType] = donatedPet;
          this.donatedPets.push(this['donatedPet' + petType]);
        } else {
          var url = urlPetDonated + this.customer + '/' + petType;
          $.get(url, function (data) {
            localStorage.setItem('donatedPet' + petType, JSON.stringify(data));
            data.donated = donated;
            self['donatedPet' + petType]  = data;
            self.donatedPets.push(self['donatedPet' + petType]);
          });
        }
      },
      setDonatedPets: function(items) {
        let dog = 0;
        let cat = 0;
        let dogFood = 0;
        let catFood = 0;
        for(let i=0; i < items.length; i++) {
          let item = items[i];
          let properties = item.properties;
          if(properties) {
            if(properties.perro) {
              if(properties.donar) {
                dogFood += parseInt(item.variant_title.split(' ')[0]);
              } else {
                dog += item.price * item.quantity / 100;
              }
            }
            if(properties.gato) {
              if(properties.donar) {
                catFood += parseInt(item.variant_title.split(' ')[0]);
              } else {
                cat += item.price * item.quantity / 100;
              }
            }
          }
        }
        this.donatedPets = [];
        let donated = this.donated(dog, 1) + dogFood;
        if(donated > 0) {
          this.getDonatedPets(1, donated);
        }
        donated = this.donated(cat, 2) + catFood;
        if(donated > 0) {
          this.getDonatedPets(2, donated);
        }
      },
      prev: function () {
        this.viewMore = false;
        if (this.page > 0) {
          this.page -= 1;
        }
      },
      next: function () {
        this.viewMore = 0;
        if (this.page < this.maxPages) {
          this.page += 1;
        }
      },
      more: function (petType, name) {
        console.log(petType);
        this.viewMore = 1;
        this.moreName = name;
        if(petType != 'cats') {
          this.product = this.dogProduct;
        } else {
          this.product = this.catProduct;
        }
      },
      getProducts: function() {
        var self = this;
        console.log(this.handleCatProduct);
        console.log(this.handleDogProduct);
        $.get('/products/' + this.handleCatProduct + '.json', function (data) {
          self.catProduct = data.product;
        });
        $.get('/products/' + this.handleDogProduct + '.json', function (data) {
          self.dogProduct = data.product;
        });
      },
      addToCart: function (variant) {
        var data = {
          id: variant.id,
          quantity: 1,
          properties: {
            'gato': this.product.tags.indexOf("Gato") >= 0,
            'perro': this.product.tags.indexOf("Perro") >= 0,
            'donar': true
          }
        };
        var self = this;
        $.ajax({
          url: '/cart/add.js',
          data: JSON.stringify(data),
          type: 'POST',
          contentType: 'application/json',
          dataType: 'json'
        }).done(function (data) {
          console.log(data);
          self.moreQuantity = variant.title.split(' ')[0];
          self.viewMore = 2;
          setTimeout(function () {
            //debugger;
            self.viewMore = 0;
            self.$emit('update');
          }, 2 * 1000);
        }).fail(function (data) {
          console.log(data);
          alert('Ocurrio un error.');
        });
      }
    },
    mounted: function () {
      console.log('mounted donation-products');
      this.isPhone = window.isPhone;
      this.isTablet = window.isTablet;
      this.getProducts();
    }
  });

});